import React from "react";
import Slider from "react-slick";

import "../../styles/testimonial.css";

import ava01 from "../../assets/all-images/voda-logo.png";
import ava02 from "../../assets/all-images/Nokia-Logo1.png";
import ava03 from "../../assets/all-images/tigo-logo.png";
import ava04 from "../../assets/all-images/bam-logo.png";
import ava05 from "../../assets/all-images/caroil-logo.jpg";
import ava06 from "../../assets/all-images/airtel.jpeg";



const Testimonial = () => {
  const settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    speed: 1000,
    swipeToSlide: true,
    autoplaySpeed: 2000,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    
    <Slider {...settings}>
      <div className="testimonial py-5 px-0">
    
        <div className="mt-3 d-flex align-items-center gap-4">
          <img src={ava01} alt="" className="w-25 h-25 rounded-2" />

          <div>
            <h6 className="mb-0 mt-3">Vodacom Company</h6>
            <p className="section_description">Partner</p>
          </div>
        </div>
      </div>

      <div className="testimonial py-4 px-3">
        <p className="section_description">
          
       
        </p>

        <div className="mt-3 d-flex align-items-center gap-4">
          <img src={ava02} alt="" className="w-25 h-25 rounded-2" />

          <div>
            <h6 className="mb-0 mt-3">Nokia Company</h6>
            <p className="section_description">Client</p>
          </div>
        </div>
      </div>

      <div className="testimonial py-4 px-3">
        <p className="section_description">
          
        
        </p>

        <div className="mt-3 d-flex align-items-center gap-4">
          <img src={ava03} alt="" className="w-25 h-25 rounded-2" />

          <div>
            <h6 className="mb-0 mt-3">Yas Company</h6>
            <p className="section_description">Client</p>
          </div>
        </div>
      </div>

      <div className="testimonial py-4 px-3">
        <p className="section_description">
       
        </p>

        <div className="mt-3 d-flex align-items-center gap-4">
          <img src={ava04} alt="" className="w-25 h-25 rounded-2" />

          <div>
            <h6 className="mb-0 mt-3">Bam Company</h6>
            <p className="section_description">Client</p>
          </div>
        </div>
      </div>
      <div className="testimonial py-4 px-3">
        <p className="section_description">
        

        </p>

        <div className="mt-3 d-flex align-items-center gap-4">
          <img src={ava05} alt="" className="w-25 h-25 rounded-2" />

          <div>
            <h6 className="mb-0 mt-3">Caroil Company</h6>
            <p className="section_description">Partner</p>
          </div>
        </div>
      </div>
      <div className="testimonial py-4 px-3">
        <p className="section_description">
        

        </p>

        <div className="mt-3 d-flex align-items-center gap-4">
          <img src={ava06} alt="" className="w-25 h-25 rounded-2" />

          <div>
            <h6 className="mb-0 mt-3">Airtel Company</h6>
            <p className="section_description">Client</p>
          </div>
        </div>
      </div>
    </Slider>
  );
};

export default Testimonial;